import Main from './FinancialDashboard'

const FinancialDashboard = {
  Main,
}

export default FinancialDashboard
